import { useCallback, useContext } from "react";
import { AuthContext, fp } from "../App";
import Constants from "../utils/Constants";
import { useFetch } from "../hooks/useFetch";

const apiBaseUrl = Constants.SERVER_URL;

const useOrderNote = () => {
  const { authState } = useContext(AuthContext);
  const { send } = useFetch();

  const findAll = useCallback(
    async (query) => {
      const url = apiBaseUrl + "/wapi/orderNotes?orderType=" + query.orderType + "&orderId=" + query.orderId;
      const config = {
        method: "get",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
      };

      return await send(url, config);
    },
    [authState.token, send]
  );

  const add = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
        body: JSON.stringify(params),
      };

      return await send(apiBaseUrl + "/wapi/orderNotes/add", config);
    },
    [authState.token, send]
  );

  return { findAll, add };
};

export { useOrderNote };
